import { Box } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { detailsTickets } from 'src/redux/Calendar/sliceCalendar';
import { TicketsMasterUpdateForm } from './TicketsMasterUpdateForm';
import { TicketsUpdateForm } from './TicketsUpdateForm';

export const TicketsContent = ({ comission }: { comission: string }) => {
  const data = useSelector(detailsTickets);
  if (!data) return null;
  return (
    <>
      <TicketsMasterUpdateForm comission={comission} />
      {Object.keys(data).map((i) => (
        <Box key={i} mb={4}>
          <TicketsMasterUpdateForm comission={comission} schedule_id={+i} />
          {Object.keys(data[i]).map((date) => (
            <TicketsUpdateForm
              key={`${i}_${date}`}
              state={data[i][date]}
              comission={comission}
              date={date}
              schedule_id={i}
            />
          ))}
        </Box>
      ))}
    </>
  );
};
